// extracted by mini-css-extract-plugin
export default {"container":"template-sent_container__lh8Tn"};